/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Empty"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let tabSelectedLedgerPayorsValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.payors',
})
let payorValueData = fromData.useDataValue({ viewPath,
context: 'payor',
})
let aggregateData = fromHelpers.isSelected(tabSelectedLedgerPayorsValueData, payorValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let payorTextValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'text',
})
let tabSelectedLedgerPayorsValueData1 = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.payors',
})
let payorValueData1 = fromData.useDataValue({ viewPath,
context: 'payor',
})
let aggregateData1 = fromHelpers.isSelected(tabSelectedLedgerPayorsValueData1, payorValueData1)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<button
  data-testid="Empty.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--pt-1-4PwO0': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-2-4PwO0': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-3-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btlr-5-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btrr-6-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bblr-7-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbrr-8-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-9-4PwO0': aggregateData ? dtColorsGreen700 : dtColorsNeutral300,'--bc-10-4PwO0': aggregateData ? dtColorsGreen700 : "transparent"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payor.text"
 text={payorTextValueData}
 weight="medium"
 color={aggregateData1 ? dtColorsWhite : dtColorsNeutral900}
 whiteSpace="nowrap"
 data="tab.selected.ledger.payors"
 data="payor"
 aggregate="helpers.js isSelected"
/>
</button>
{children}
</React.Fragment>)
}